import {createIntl, createIntlCache} from 'react-intl'
import langObj from '@src/locale/lang'
import {getLang} from '@src/utils'

const cache = createIntlCache()
const intl = createIntl(
    {
        locale: getLang(),
        messages: langObj[getLang()],
    },
    cache
)
export default intl
